import { defineStore } from 'pinia'
import { picturePath } from '@/utils'
import { globalInfoGet, customerLogoGet } from '@/apis/brand'
import { getCache, setCache } from '@/utils/cache/local'
import { isEmpty } from '@/utils/is'
import { usePermissionStore } from '@/stores/modules/permission'
import { useResource } from '@/hooks/useResource'
import { getAuthorizerInfo } from '@/apis/systemManage/wxAuth'
import globalEnv from '@/configs'
// 功能下线：财智通资质接口暂不请求
// import { getSpecialize } from '@/apis/systemManage/userManage'
const buildEnv = import.meta.env.VITE_APP_BUILD_ENV
enum showEnum {
  FINISH = 'PROCESS_FINISH',
  ON = 'PROCESS_ON'
}
function handleIcoCreate(icoUrl: string) {
  const link: any = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.rel = 'shortcut icon'
  link.href = icoUrl
  document.getElementsByTagName('head')[0].appendChild(link)
}
const VITE_APP_DEFAULT_LOGO = import.meta.env.VITE_APP_DEFAULT_LOGO
const VITE_APP_LAYOUT_LOGO = import.meta.env.VITE_APP_LAYOUT_LOGO
const VITE_APP_FAVICON_ICON = import.meta.env.VITE_APP_FAVICON_ICON
const defaultLogo = VITE_APP_DEFAULT_LOGO
  ? new URL(VITE_APP_DEFAULT_LOGO, import.meta.url).href
  : new URL(
      `/src/assets/images/icon/logo/${buildEnv === 'erp' ? 'erp' : 'base'}/logo2.png`,
      import.meta.url
    ).href
const homeLogo = VITE_APP_LAYOUT_LOGO
  ? new URL(VITE_APP_LAYOUT_LOGO, import.meta.url).href
  : new URL(
      `/src/assets/images/icon/logo/${buildEnv === 'erp' ? 'erp' : 'base'}/logo.png`,
      import.meta.url
    ).href

export const useOrgInfoStore = defineStore('orgInfo', {
  state: (): any => {
    return {
      sysInfo: {
        sysName: '',
        sysLogo: '',
        icon: '',
        config: {}
      },
      wxConfig: {
        expire: true
      },
      // 财智通资质
      speacialize: [],
      loginVisible: false,
      brandInfo: {},
      defaultLogo,
      homeLogo
    }
  },
  actions: {
    showLoginVisible(val: boolean) {
      this.loginVisible = val
    },
    setOrgInfo(data: any, isLogin = true) {
      const { getMenuAuth } = useResource()
      const usePermission = usePermissionStore()
      const { tenantIdEn } = data
      this.sysInfo.sysName = ''
      this.sysInfo.sysLogo = ''
      this.sysInfo.icon = ''
      try {
        Object.assign(this.sysInfo, {
          ...this.sysInfo,
          sysName: data.sysName || globalEnv.websiteName,
          sysLogo: data.sysLogo
            ? picturePath(data.sysLogo)
            : isLogin
            ? this.homeLogo
            : this.defaultLogo,
          loginLogo: data.sysLogo ? picturePath(data.sysLogo) : this.defaultLogo,
          icon: data.icon
            ? picturePath(data.icon)
            : data.updateTime && tenantIdEn
            ? 'data:;base64,='
            : new URL(
                VITE_APP_FAVICON_ICON || `/public/${buildEnv === 'erp' ? 'erp' : 'base'}/logo.ico`,
                import.meta.url
              ).href
        })
        const icon = this.sysInfo.icon
        // 没有品牌自定义权限
        const notHasICMenu =
          !unref(!!unref(usePermission.systemListData).find((item: any) => item.code === 'IC')) ||
          !getMenuAuth('CustomBrand')
        document.title =
          this.sysInfo.sysName ||
          (notHasICMenu && !window.location.hash.includes('#/login') ? globalEnv.websiteName : '')
        handleIcoCreate(icon)
        // 设置缓存
        if (data.tenantIdEn) {
          setCache('tenantIdEn', data.tenantIdEn)
        }
      } catch (e) {
        console.log(e, '123')
      }
    },
    setBrandInfo(data: Recordable) {
      this.brandInfo = {}
      try {
        if (!isEmpty(data)) {
          Object.assign(this.brandInfo, {
            ...(data as Recordable),
            appShow: (data as Recordable).appShow?.code === 1
          })
        }
      } catch (e) {
        console.log(e, '123')
      }
    },
    globalInfo(key: any = getCache('tenantIdEn'), isLogin = true) {
      return new Promise(resolve => {
        globalInfoGet({
          key,
          exclusiveHost: window.location.host
        })
          .then(
            res => {
              this.setOrgInfo(res.organCustomInfo || { tenantIdEn: key }, isLogin)
              this.setBrandInfo(res.customBrand || {})
            },
            () => {
              // this.setOrgInfo({ tenantIdEn: key })
            }
          )
          .finally(() => {
            resolve(true)
          })
      })
    },
    getOrgLogo(isLogin = true) {
      return customerLogoGet().then(res => {
        this.setOrgInfo(res || {}, isLogin)
      })
    },
    ifShow(type: string) {
      return this.brandInfo[type] === showEnum.FINISH
    },
    getUrl(url: string) {
      return picturePath(this.brandInfo[url])
    },
    // 获取微信授权信息
    async fetchWxConfig(data: any): Promise<any> {
      try {
        const res = await getAuthorizerInfo(data)
        this.wxConfig = res
      } catch (error) {
        console.error('Failed to fetch wxConfig:', error)
        throw error
      }
    },
    // 获取财智通资质
    // 功能下线：DIS 网关 gw.youljrong.com 不可用，暂不请求 /dis/h5/getSysParamByCode?code=get_flair_config_key
    async fetchSpecialize() {
      return
      // try {
      //   const res = await getSpecialize()
      //   if (res) {
      //     const data = JSON.parse(res)
      //     // 过滤掉deleteFlag为true的项
      //     const config = Object.keys(data).reduce((acc: Record<string, any>, key: string) => {
      //       acc[key] = {
      //         ...data[key],
      //         options: data[key].options.filter((option: any) => !option.deleteFlag)
      //       }
      //       return acc
      //     }, {} as Record<string, any>)
      //     const typeMap = [
      //       { key: 'enterprise', value: '1', label: config.enterprise.title },
      //       { key: 'personal', value: '2', label: config.personal.title },
      //       { key: 'merchant', value: '3', label: config.merchant.title }
      //     ]
      //     // 转换为目标结构
      //     this.speacialize = typeMap.map(item => ({
      //       value: item.value,
      //       label: item.label,
      //       children: config[item.key].options.map((option: { value: string; label: string }) => ({
      //         value: option.value,
      //         label: option.label
      //       }))
      //     }))
      //   }
      // } catch (error) {}
    }
  },
  getters: {
    brandByied(state) {
      // true 未购买 false 已购买
      return isEmpty(state.brandInfo)
    },
    // 财智通资质
    speacializeOptions(state) {
      return state.speacialize
    }
  }
})
